import { searchLabTests } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  SearchLabTestsRequestT,
  SearchLabTestsResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchSearchLabTests(
  request: SearchLabTestsRequestT,
  signal?: AbortSignal
): Promise<SearchLabTestsResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await searchLabTests(request, config);
  return lotusHealthZod.searchLabTestsResponse.parse(response.data) as SearchLabTestsResponseT;
}
